import styled from '@emotion/styled';
import React, { useState } from 'react';
import { keyframes } from '@emotion/react';

import { Media as MediaProps } from '~/types/api';
import ListGroup from '~/App/Components/ListGroup';

const ListGroupItem = styled(ListGroup.Item)`
  background-color: ${(props: { active?: string }) =>
    props.active === 'active' ? 'red' : 'unset'}
  justify-content: space-between;
  border: unset;
  position: relative;
  padding: 15px;
`;

const NoImage = styled.div`
  width: 220px;
  height: 150px;
  border: ${(props: { src?: string }) =>
    props?.src ? 'unset' : '1px solid #979797'};

  text-align: center;
  line-height: 150px;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.48px;
  color: #666666;
`;

const StyledImage = styled.img`
  width: 220px;
  height: 150px;
  z-index: 150;
  border: ${(props: { src?: string }) =>
    props?.src ? 'unset' : '1px solid #979797'};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  &.smooth-image {
    transition: opacity 1s;
    opacity: 0;
  }
  &.loaded {
    opacity: 1;
  }
`;

const preLoaderBlock = keyframes`
  from {
    background-position: 0%, 0;
  }
  to {
    background-position: 170%, 0;
  }
`;

const PreLoader = styled.div`
  position: absolute;
  z-index: 100;
  padding: 15px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(245, 245, 245, 0.34);
  .loader {
    background-image: linear-gradient(to right, #e6e6e6, #ffffff, #e6e6e6);
    width: 100%;
    height: 100%;
    display: inline-block;
    background-size: 200%;
    animation: ${preLoaderBlock} 2s linear 0s infinite reverse forwards;
  }
`;

export interface StockMediaItemProps {
  media?: MediaProps;
  onClick: () => void;
  active?: string;
}

export default function StockMediaItem({
  media,
  onClick,
  active,
}: StockMediaItemProps) {
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  if (!media?.id) {
    return (
      <ListGroupItem active={active} onClick={onClick}>
        <NoImage>None</NoImage>
      </ListGroupItem>
    );
  }

  return (
    <ListGroupItem key={media.id} active={active} onClick={onClick}>
      <StyledImage
        src={media?.url}
        className={`smooth-image ${imageLoaded ? 'loaded' : ''}`}
        onLoad={() => setImageLoaded(true)}
      />
      {!imageLoaded && (
        <PreLoader>
          <span className='loader' />
        </PreLoader>
      )}
    </ListGroupItem>
  );
}
